import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Paginator from '../../../components/paginationCustom';
import { getAuditLogList, getMasterData } from '../actions/LogActions';
import SortingCustom from '../../../components/SortingCustom';
import { Field, reduxForm, reset } from 'redux-form';
import GlobalVariables, { resetFiltersAndSorting, showFormatedDate, showFormatedDateandTime } from '../../../actions/utilAction';
import { renderAutoCompleteMultipleSelection, renderDateField } from '../../../components/reduxFields';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import {  getPatient } from '../../Billing/components/manageClaims//actions/ManageClaimActions';

class AuditLogList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PatientIds: null,
      StaffIds: null,
      ActionIds: null,
      ModuleIds: null,
      FromDate: new Date(),
      ToDate: new Date(),      
      modulelist: [{ id: 'Manage Users', value: 'Manage Users' }, { id: 'Manage Client', value: 'Manage Client'  },{ id: 'Scheduling', value: 'Scheduling'  },{ id: 'Manage Payer', value: 'Manage Payer' }
      ,{ id: 'Masters', value: 'Masters'  },{ id: 'Billing', value: 'Billing' },{ id: 'Manage Appointments', value: 'Manage Appointments'  },{ id: 'Masters Data Collection', value: 'Masters Data Collection' }],
      actionlist: [{ id: 'Create', value: 'Create' }, { id: 'Modify', value: 'Modify'  },{ id: 'Update', value: 'Update'  },{ id: 'Delete', value: 'Delete' },{ id: 'Copy', value: 'Copy'},{ id: 'Move', value: 'Move'},{ id: 'Review', value: 'Review'},{ id: 'Upload', value: 'Upload'},{ id: 'Archived', value: 'Archived'},{ id: 'Unarchived', value: 'Unarchived'},{ id: 'Restore', value: 'Restore'},{ id: 'Cancel', value: 'Cancel'}],
    };
    this.filter = {
      sort_Column: 'logDate',
      sort_Order: 'desc',
      searchText: '',
    };
    this.handleSearchAuditLog = this.handleSearchAuditLog.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    //  this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleNewRequestMultiSelect = this.handleNewRequestMultiSelect.bind(this);
  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'logDate',
      sort_order: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
      contain_filters: {
        patientIds: this.state.PatientIds ? this.state.PatientIds : '0',
        staffIds: this.state.StaffIds ? this.state.StaffIds : '0',
        actionNames: this.state.ActionIds ? this.state.ActionIds : '0',
        moduleNames: this.state.ModuleIds ? this.state.ModuleIds : '0',
        fromDate: this.state.FromDate ? moment(this.state.FromDate).format('YYYY-MM-DD') : new Date(),
        toDate: this.state.ToDate ? moment(this.state.ToDate).format('YYYY-MM-DD') : new Date(),
      },
      pageNumber: page_number ? page_number : 1,
      pageSize: GlobalVariables.PageSize,
    };

    this.props.getAuditLogList(searchObj);
  }
  componentWillMount() {
    let searchObj = {
      // locationIds: this.props.currentLocationId || '',
      locationIds: '0',
      isActiveCheckRequired: 'NO',
    };
    this.props.getPatient(searchObj);    
    this.loadData();
    let masterData = {
      'masterdata': 'MASTERSTAFFUSERS',
    };    
     this.props.getMasterData(masterData);   
  }
  handleSearchAuditLog(event) {
    // event.preventDefault();
    // console.log('event............',event);


    this.setState({
      PatientIds: event.PatientIds ? event.PatientIds : '0',
      StaffIds: event.StaffIds ? event.StaffIds : '0',
      ActionIds: event.ActionIds ? event.ActionIds : '0',
      ModuleIds: event.ModuleIds ? event.ModuleIds : '0',
      FromDate: event.FromDate ? showFormatedDate(event.FromDate) : new Date(),
      ToDate: event.ToDate ?  showFormatedDate(event.ToDate) : new Date(),
    }, () => {
      this.loadData();
    });
  }

  // handleSearchChange(event) {
  //   if (event.target.value.length > 2) {
  //     this.filter.searchText = event.target.value;
  //     this.loadData();
  //   } else if (event.target.value.length === 0) {
  //     this.filter.searchText = '';
  //     this.loadData();
  //   }
  // }
  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;
      this.loadData();
    }
  }

  handleReset = () => {
    this.props.dispatch(reset('AuditLogListForm'));
    // this.filter.sort_Column = 'logDate';
    resetFiltersAndSorting(this.filter, 'logDate', true);
    this.setState({
      PatientIds: null,
      StaffIds: null,
      ActionIds: null,
      ModuleIds: null,
      FromDate: new Date(),
      ToDate: new Date(),
    }, () => {
      this.loadData();
    });
  };
  renderData() {
    // console.log('audit data.....', this.props.auditloglist.data);
    return this.props.auditloglist.data.map((data, index) => {
      // let data = Obj.attributes;
      return (
        <tr key={index}>
          <td>{showFormatedDateandTime(data.logDate)}</td>
          <td>{data.moduleName === '' ? '-' : data.moduleName }</td>
          <td>{data.screenName}</td>
          <td>{data.fieldName === '' ? '-' : data.fieldName }</td>
          <td>{data.userName === '' ? '-' : data.userName }</td>
          {/* <td>{data.columnName}</td> */}
          <td>{data.oldValue === undefined || data.oldValue === null ? '' : data.oldValue }</td>
          <td>{data.newValue}</td>          
          <td>{data.action}</td>          
          <td>{data.createdByName}</td>
        </tr>
      );
    });
  }

  handleNewRequestMultiSelect(input, selectedValues) {
    input.onChange(selectedValues);
    if (input.name === 'PatientIds') {
      this.setState({
        PatientIds: selectedValues,
      });
    }
    else if(input.name === 'StaffIds')
    {
      this.setState({
        StaffIds: selectedValues,
      });
    }
    else if(input.name === 'ActionIds')
    {
      this.setState({
        ActionIds: selectedValues,
      });
    }
    else if(input.name === 'ModuleIds')
    {      
      this.setState({
        ModuleIds: selectedValues,
      });
    }
  }


  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'tableAuditLog': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });

    return (
      <div>
        <h2 className="page_title">Audit Log</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form mtm-27" onSubmit={handleSubmit(this.handleSearchAuditLog)}>

              <div className="row">                
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="PatientIds"
                    label="Client Name"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.patientlist}
                    component={renderAutoCompleteMultipleSelection} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="StaffIds"
                    label="User Name"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.props.staffUsers}
                    component={renderAutoCompleteMultipleSelection} />
                </div>
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="ActionIds"
                    label="Action Name"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.state.actionlist}
                    component={renderAutoCompleteMultipleSelection} />
                </div>                
              </div>
              <div className="row">
                <div className="col-sm-4 insfield mt-35">
                  <Field
                    name="ModuleIds"
                    label="Module Name"
                    handleNewRequest={this.handleNewRequestMultiSelect}
                    options={this.state.modulelist}
                    component={renderAutoCompleteMultipleSelection} />
                </div>   
                <div className="col-sm-4 col-md-4">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection = {true}
                    component={renderDateField} />

                </div>
                <div className="col-sm-4 col-md-4">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection = {true}
                    component={renderDateField} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 btn_rt reset-btn">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Filter</RaisedButton>
                  <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                </div>
              </div>
            </form>
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-15">

                  {this.props.auditloglist.data && this.props.auditloglist.data.length ?
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="12%"><SortingCustom setSortColumn={this.setSortColumn} columnName='logDate' displayName='Date' /></th>
                          <th width="10%">Module Name</th>
                          <th width="12%">Screen Name</th>
                          <th width="12%">Field Name</th>
                          <th width="15%">Name</th>
                          {/* <th width="10%">Column</th> */}
                          <th width="12%">Old Value</th>
                          <th width="12%">New Value</th>                          
                          <th width="8%">Action</th>                          
                          <th width="22%">Logged By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderData()}
                      </tbody>
                    </table>
                    :
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="12%">Date</th>
                          <th width="10%">Module Name</th>
                          <th width="12%">Screen Name</th>
                          <th width="12%">Field Name</th>
                          <th width="15%">Name</th>
                          {/* <th width="10%">Column</th> */}
                          <th width="12%">Old Value</th>
                          <th width="12%">New Value</th>                          
                          <th width="8%">Action</th>                          
                          <th width="22%">Logged By</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="10">
                            <div className="familydl text-center no-record">No record found!</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  }
                </div>
                {this.props.auditloglist.data && this.props.auditloglist.data.length ?
                  <Paginator data={this.props.auditloglist.meta} handlePageChange={(page_number) => this.loadData(page_number)} />
                  : null}
              </div>
            </div>


          </div>
        </div>
      </div>
    );
  }
}
AuditLogList = reduxForm({
  form: 'AuditLogListForm',
  enableReinitialize: true,
})(AuditLogList);

function mapStateToProps(state) {
  // console.log('state..........', state.logs);
  let patients = [];
  if (state.billing.patientList && state.billing.patientList.data) {
    patients = state.billing.patientList.data.patients;
  }
  return {
    patientlist: patients,    
    auditloglist: state.logs.auditloglist,
    staffUsers : state.logs.master_data ? state.logs.master_data.staffUsers : [],    
  };

}
export default connect(mapStateToProps, { getAuditLogList, getPatient, getMasterData })(AuditLogList);



// WEBPACK FOOTER //
// ./src/modules/Logs/components/audit_log.js